// import Logo from '../assets/img/foodvilla.png';
import logo from "../logo1.png";
const Title = () => {
     return (
          <a href="/">
               <img 
               className='w-80 h-40 m-2 p-2 rounded-full'
               // className='logo' 
               src={logo} alt="logo" />
          </a>
     )
};

export default Title;